import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ProductCardComponent } from '../product-card.component';
import { RouterLink } from '@angular/router';
import { ContentImagePipe } from '../../../../pipes/cms-image.pipe';
import { SavingsComponent } from '../savings/savings.component';
import { ProductImageSetPipe } from '../../../../pipes/product-image-set.pipe';
import { PrimaryProductImagePipe } from '../../../../pipes/primary-product-image.pipe';
import { AsyncPipe, DecimalPipe, NgStyle } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { PriceFieldComponent } from '../../price-field/price-field.component';
import { TextButtonComponent } from '../../../button';
import { CounterComponent } from '../../counter/counter.component';

@Component({
  selector: 'app-online-product-card',
  templateUrl: './online-product-card.component.html',
  styleUrls: ['./online-product-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    RouterLink,
    ContentImagePipe,
    SavingsComponent,
    ProductImageSetPipe,
    PrimaryProductImagePipe,
    NgStyle,
    MatIconModule,
    PriceFieldComponent,
    DecimalPipe,
    TextButtonComponent,
    AsyncPipe,
    CounterComponent,
  ],
})
export class OnlineProductCardComponent extends ProductCardComponent {
  constructor() {
    super();
  }
}
